module.exports = __webpack_public_path__ + "img/settings.37b89df7.png";